import styled from 'styled-components';

export const ModalWrapper = styled.div`
  padding: 5px 15px 10px;
  margin: 0;
  width: 100%;
  max-width: 400px;
`;

export const HeadingContainer = styled.div`
  margin-top: -10px;
  margin-bottom: 10px;
  text-align: center;

  h3 {
    margin-bottom: 10px;
    text-align: center;
    font-size: 1.1em;
  }

  p {
    margin-bottom: 5px;
    font-size: 0.9em;
  }
`;

export const AmountContainer = styled.div`
  background-color: #f5f5f5;
  border-radius: 4px;
  padding: 6px;
  margin-bottom: 8px;
  text-align: center;

  .label {
    font-weight: bold;
    margin-bottom: 2px;
    font-size: 0.85em;
  }

  .amount {
    font-size: 1em;
  }
`;
